module.exports = __webpack_public_path__ + "img/drt18.05fc516f.png";